import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import getUniqueAttendees from './getUniqueAttendees';
import { freeBusyCache, isConflictFromFreeBusy } from 'owa-freebusy-cache';
import type { OwaDate } from 'owa-datetime';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Gets the conflict count for a collection of attendees and start/end times
 * @param attendees The Attendee Collection
 * @param start Start time
 * @param end End time
 * @param filter: An optional CalendarEvent to filter out of the results
 */
export default function getConflictCount(
    attendees: AttendeeType[],
    start: OwaDate,
    end: OwaDate,
    filter?: CalendarEvent
) {
    return getUniqueAttendees(attendees)
        .map(attendee =>
            freeBusyCache.getAggregatedFreeBusy(
                attendee.Mailbox.EmailAddress,
                start,
                end,
                false, // All Day
                filter
            )
        )
        .filter(freeBusy => isConflictFromFreeBusy(freeBusy)).length;
}
